export const API_ENDPOINTS = {
  // Upload endpoints
  UPLOAD_IMAGE: "/api/upload/image",
  UPLOAD_IMAGES: "/api/upload/images",
  UPLOAD_VIDEO: "/api/upload/video",

  // Auth endpoints
  LOGIN: "/api/auth/login",
  REGISTER: "/api/auth/register",
  REGISTER_CHALLENGE: "/api/auth/register-challenge",
  LOGOUT: "/api/auth/logout",
  REFRESH_TOKEN: "/api/auth/refresh",
  VERIFY_TOKEN: "/api/auth/verify",
  REQUEST_PASSWORD_RESET: "/api/auth/request-password-reset",
  RESET_PASSWORD: "/api/auth/reset-password",
  VERIFY_RESET_TOKEN: "/api/auth/verify-reset-token",
  CATEGORIES: "/api/categories",

  // Auction endpoints
  AUCTIONS: "/api/auctions",
  GET_ITEMS: "/api/auctions/items",
  GET_AUCTIONS: "/api/auctions/history",
  CREATE_AUCTION: "/api/auctions/items",
  GET_AUCTION: "/api/auctions/items",
  GET_LIVE_AUCTIONS: "/api/auctions/auction_live",
  GET_LIVE_AUCTION_DETAIL: "/api/auctions/auction_live",
  UPDATE_LIVE_AUCTION: "/api/auctions/auction_live",
  UPDATE_AUCTION: "/api/auctions/items",
  DELETE_AUCTION: "/api/auctions/items",
  APPROVE_AUCTION: "/api/auctions/items",

  // Admin endpoints
  APPROVE_PENDING_ITEM: "/api/adm/items",
  REJECT_PENDING_ITEM: "/api/adm/items",
  DELETE_PENDING_ITEM: "/api/adm/items",

  // Bid endpoints
  BIDS: "/api/auctions/bid",
  PLACE_BID: "/api/auctions/bids",
  GET_BIDS: "/api/auctions/bid",

  // User endpoints
  USERS: "/api/users",
  AUTH: "/api/auth",

  // WhatsApp endpoints
  REQUEST_WHATSAPP_UPDATE: "/api/whatsapp/request-update",
  UPDATE_WHATSAPP: "/api/whatsapp/update",
  VERIFY_WHATSAPP_TOKEN: "/api/whatsapp/verify-token",

  // New endpoints
  GET_MY_ITEMS: "/api/auctions/my-items",
  VERIFY_SESSION: "/api/auth/verify",
  GET_USER_PROFILE: "/api/users/profile",
  UPDATE_USER_PROFILE: "/api/users/profile",
  GET_BLOG_POSTS: "/api/blog",

  // GIS endpoints
  GET_GIS_PROPERTIES: "/api/gis/",
  GET_GIS_PROPERTY: "/api/gis/",
} as const;
